// @flow
import React, { Component } from 'react';
import { type ReactObjRef } from '../../../../utilities/types';
import { type FieldProps } from 'redux-form';
import {
  CryptoWalletsTextDiv,
  ExtWalletDiv,
  ExtWalletLabel,
  AddressErrorSpan,
  ExtAddressInput,
  ExtAddressInputWrapperDiv,
  EditLink,
  EyeIcon
} from '../CryptoWalletsStyles';
import { TextLink } from '../../../../components/LinkStyles';

type Props = {
  iso: string,
  disabled?: boolean
} & FieldProps;
type State = {
  edit: boolean,
  touched: boolean,
  secure: boolean
};

export default class ExtWalletInput extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.inputRef = React.createRef();
  }
  inputRef: ReactObjRef<'input'>;
  state = { edit: false, touched: false, secure: true };

  handleAddClick = () => {
    if (!this.props.disabled) {
      this.setState({ edit: true, secure: false });
      if (this.inputRef.current) {
        this.inputRef.current.focus();
      }
    }
  };

  handleBlur = (event: SyntheticEvent<HTMLInputElement>) => {
    this.setState({ edit: false, touched: true, secure: true });
    this.props.input.onBlur(event);
  };

  toggleSecure = () => {
    this.setState({ secure: !this.state.secure });
  };

  render() {
    const { dirty } = this.props.meta;
    const displayEdit = !this.state.edit && !this.props.meta.error && !dirty;

    if (!(this.props.input.value || this.state.edit) && !dirty) {
      return (
        <CryptoWalletsTextDiv>
          <p>
            Please add an{' '}
            <TextLink onClick={this.handleAddClick}>
              External Wallet Address
            </TextLink>{' '}
            to enable automatic withdraws.
          </p>
        </CryptoWalletsTextDiv>
      );
    }
    const displayValue =
      !this.state.secure || dirty ? this.props.input.value : '********';
    return (
      <ExtWalletDiv>
        <ExtWalletLabel>
          Wallet Address{' '}
          {this.state.touched && this.props.meta.error && (
            <AddressErrorSpan>{this.props.meta.error}</AddressErrorSpan>
          )}
        </ExtWalletLabel>
        <ExtAddressInputWrapperDiv>
          <ExtAddressInput
            {...this.props.input}
            value={displayValue}
            meta={this.props.meta}
            readOnly={!this.state.edit && !dirty}
            onBlur={this.handleBlur}
            ref={this.inputRef}
            autoFocus={!this.props.input.value}
            onClick={this.handleAddClick}
            touched={this.state.touched}
          />
          {displayEdit && (
            <>
              <EditLink onClick={this.handleAddClick}>Edit </EditLink>
              {dirty || (
                <div onClick={this.toggleSecure}>
                  <EyeIcon name={this.state.secure ? 'eyeHide' : 'eyeShow'} />
                </div>
              )}
            </>
          )}
        </ExtAddressInputWrapperDiv>
      </ExtWalletDiv>
    );
  }
}
